<template>
  <div>
     <div v-if="isViewEnable">
      <span v-if="isWatchApproved" class="cs-appointment-green">{{watchApprovedText}}</span>
      <!-- <el-button
        v-else
        :disabled="btnDisabled"
        type="primary"
        size="mini"
        @click="onWatchApproved"
      >确认观看</el-button> -->
      </div>
  </div>
</template>

<style lang="scss" scoped>
  .cs-appointment-green {
    color: #009145;
  }
  .cs-appointment-red {
    color: #e1272d;
  }
</style>

<script>
import {
  updateWatchApproved,
} from "../../../service/videoAppointment.service";
import global_ from "../../../core/global";

export default {
  props: {
    data: {},
    columnData: {},
    status: {}
  },
  data() {
    return {
      isWatchApproved: false,
      btnDisabled: false,
      watchApprovedText: '',
      isViewEnable : false
    };
  },
  components: {},
  created() {
    this.init();
  },
  methods: {
    init() {
      if (!!this.data) {
        this.isWatchApproved = this.data.IsWatchApproved;
        this.watchApprovedText = this.data.WatchApprovedText;
        this.isViewEnable = this.data.ViewEnable;
      }
    },   
    onWatchApproved() {
      let phone = this.data.StudentPhone;
      let courseWeekString = this.data.CourseWeekString;
      let message = `是否确认学生${phone}可观看${courseWeekString}的视频?`;
      let data = {
        name: "watchApprove",
        id: this.data.Id,
        phone: phone,
        courseWeekString: courseWeekString,
      };
      this.$emit("customEvent", data);
      // this.$confirm(message, "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning"
      // })
      //   .then(() => {
      //     this.btnDisabled = true;

      //     updateWatchApproved(this.data.Id)
      //       .then(result => {
      //         if (!!result && result.success) {
      //           this.$emit("reload");
      //         } else {
      //           this.$message.error(result.message);
      //         }

      //         this.btnDisabled = false;
      //       })
      //       .catch(err => {
      //         this.btnDisabled = false;
      //       });
      //   })
      //   .catch(() => {});
    },
  },
  watch: {
    data: function() {
      this.init();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/appointmentWatchStatusCell.vue